import { useMemo, useState } from 'react'
import { router } from '@inertiajs/react'

import { csrfToken } from '../../../utils/csrfToken'

export default function New({ applicableDate, template, errors }) {
  const initialContent = useMemo(() => template || '', [template])
  const [applicableDateValue, setApplicableDateValue] = useState(applicableDate || '')
  const [content, setContent] = useState(initialContent)
  const [isPublic, setIsPublic] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const normalizedErrors = errors && Object.keys(errors).length ? errors : null
  const [fieldErrors, setFieldErrors] = useState(normalizedErrors)

  async function submit(e) {
    e.preventDefault()
    setSaving(true)
    setError(null)
    setFieldErrors(null)

    const response = await fetch('/users/daily_reports', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken() || '',
        Accept: 'application/json',
      },
      body: new URLSearchParams({
        'daily_report[applicable_date]': applicableDateValue,
        'daily_report[content]': content,
        'daily_report[is_public]': isPublic ? '1' : '0',
      }),
      credentials: 'same-origin',
    })

    if (response.status === 201) {
      router.visit('/users/daily_reports')
      return
    }

    if (response.status === 422) {
      const payload = await response.json()
      const nextErrors = payload.errors && Object.keys(payload.errors).length ? payload.errors : null
      setFieldErrors(nextErrors)
      setError(null)
      setSaving(false)
      return
    }

    setError(`Failed to create report: ${response.status}`)
    setSaving(false)
  }

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-8">
          <div className="mb-4">
            <h1>Create Daily Report</h1>
            <button type="button" className="btn btn-link p-0" onClick={() => router.visit('/users/daily_reports')}>
              &lt; Back
            </button>
          </div>

          {error ? <div className="alert alert-danger">{error}</div> : null}
          {fieldErrors ? (
            <div className="alert alert-danger">
              <div>Daily Report was not saved</div>
            </div>
          ) : null}

          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label" htmlFor="applicable_date">
                Applicable date
              </label>
              <input
                id="applicable_date"
                type="date"
                className="form-control"
                value={applicableDateValue}
                onChange={(e) => setApplicableDateValue(e.target.value)}
              />
              {fieldErrors?.applicable_date ? (
                <div className="invalid-feedback d-block">{fieldErrors.applicable_date.join(', ')}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="content">
                Content
              </label>
              <textarea
                id="content"
                className="form-control"
                rows={10}
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
              {fieldErrors?.content ? (
                <div className="invalid-feedback d-block">{fieldErrors.content.join(', ')}</div>
              ) : null}
            </div>

            <div className="form-group">
              <div className="form-check">
                <input
                  id="is_public"
                  type="checkbox"
                  className="form-check-input"
                  checked={isPublic}
                  onChange={(e) => setIsPublic(e.target.checked)}
                />
                <label className="form-check-label" htmlFor="is_public">
                  Share publicly on Shared Learnings
                </label>
                <div className="form-text">
                  Public reports are visible to everyone in your company. Private by default.
                </div>
              </div>
            </div>

            <div className="form-group">
              <button type="submit" className="btn w-100 btn-primary" disabled={saving}>
                {saving ? 'Creating…' : 'Create Daily Report'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
